module.exports = __webpack_public_path__ + "static/media/header-white-mask.6517bd8b.png";